import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RemoteConfigStore, SOFTLINE_FEATURE_REMOTE_CONFIG } from '@softline/application';
import { Store } from '@softline/core';
import { RetourenKopf } from '../data/retouren-kopf';
import { SOFTLINE_FEATURE_MDE_RETOUREN } from '../retouren.shared';
import { RetourenStore } from '../store/retouren.store';
import {
  extractRemoteConfiguration,
  RetourenRemoteConfiguration,
} from '../utils/extract-remote-configuration';

export const MODULE_NAME = 'mde-retouren';

type RetourenData = { kopf?: RetourenKopf | null } & RetourenRemoteConfiguration;

@Injectable()
export class RetourenResolver {
  private readonly store = inject(Store);

  async resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<RetourenData> {
    const kopf = this.store.get(
      SOFTLINE_FEATURE_MDE_RETOUREN,
      RetourenStore.getters.kopf
    );

    const config = this.store.get(
      SOFTLINE_FEATURE_REMOTE_CONFIG,
      RemoteConfigStore.getters.data
    );
    const module = config?.modules?.find((o) => o.module === MODULE_NAME);

    return {
      kopf,
      ...extractRemoteConfiguration(module?.properties ?? []),
    };
  }
}
